import { createFileRoute, notFound } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { isUuid } from '@leanin/shared';
import { useMember } from '@/lib/use-session';
import { resourcesKeys } from '@/lib/queries/resources';
import { isNotFoundApiError } from '@/lib/api-error';
import { NotFoundPage } from '@/components/shell/NotFoundPage';
import { ResourceArticleView } from './-components/ResourceArticleView';

export const Route = createFileRoute('/_authed/resources/$id/')({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.id)) throw notFound();
  },
  component: ResourceDetailPage,
});

function ResourceDetailPage() {
  const { id } = Route.useParams();
  const me = useMember();

  const resourceQuery = useQuery({
    ...resourcesKeys.detail(id),
    retry: false,
  });
  const resource = resourceQuery.data ?? null;
  const relatedQuery = useQuery({
    ...resourcesKeys.related(id, {
      tagSlug: resource?.tags[0]?.slug,
      kind: resource?.kind,
    }),
    enabled: resource !== null,
  });

  // 404 → branded NotFoundPage directly (render-context `throw notFound()`
  // lands in TanStack's catch-boundary, not its 404 surface).
  if (isNotFoundApiError(resourceQuery.error)) return <NotFoundPage />;
  if (resourceQuery.isError) throw notFound();
  if (me === null) return null;

  const viewerIsAdmin = me.platformRole === 'admin';
  const viewerCanEdit = viewerIsAdmin;

  return (
    <ResourceArticleView
      resourceId={id}
      resource={resource}
      related={relatedQuery.data ?? null}
      viewerIsAdmin={viewerIsAdmin}
      viewerCanEdit={viewerCanEdit}
    />
  );
}
